import * as React from 'react';

import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';

interface Props {
  title: string;
  wrappedNode: React.ReactNode;
  placement?: string;
}

// @ts-ignore
const SubTooltipComponent = withStyles(() => ({
  tooltip: {
    backgroundColor: '#67a8c5',
    color: 'white',
    fontSize: 15,
    padding: '8px',
    fontWeight: '500',
  },
}))(Tooltip);

export const SubTooltip = ({ title, wrappedNode, placement }: Props) => {
  const tooltipPosition = placement ? placement : 'top';

  return (
    <SubTooltipComponent
      placement={tooltipPosition}
      title={title}>
      {wrappedNode}
    </SubTooltipComponent>
  );
};

export default React.memo(SubTooltip);
